import Client from 'config/axios';
import posthog from 'posthog-js';

export const approveSuggestedPost = async (
  token: string,
  id: any,
  points: any
) => {
  const body = {
    status: 'approved',
    points: points,
    message: ''
  };
  const { data } = await Client.post(
    `suggested_post/aprove_reject/${id}`,
    body,
    {
      headers: {
        Authorization: `Bearer ${token}`
      }
    }
  );
  posthog.capture('Aprobar Propuesta de Campaña', {
    ApproveSuggestedPost: data
  });
  return {
    data
  };
};
